// extracted by mini-css-extract-plugin
export var chip = "_4p-0";
export var filterDropdown = "_4p-5";
export var filterItem = "_4p-6";
export var icon = "_4p-1";
export var removeButton = "_4p-3";
export var removeIcon = "_4p-4";
export var separator = "_4p-2";